<template>
	<ul class="accordion">
		<slot></slot>
	</ul>
</template>

<script>
export default {
	props: {},
	data() {
		return {
			Accordion: {
				count: 0,
				active: null,
			},
		};
	},
	provide() {
		return { Accordion: this.Accordion };
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.accordion {
	list-style: none;
	padding: 0;
	margin: 72px 0 0;
	gap: 0;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	/* border-top: 1px solid var(--white); */
	border-bottom: 1px solid var(--white);
	/* border-bottom: 1px solid var(--charcoal); */

	&:first-of-type {
		margin: 0 0 0;
	}

	.faq_anchor {
		display: block;
		position: relative;
		top: -100px;
		visibility: hidden;
	}

	.faq_category {
		margin-bottom: 24px;
		font-weight: bold;
	}

	// &__item:last-child {
	// 	border-bottom: none;
	// }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/AccordionWrapper.vue